import { Attachment } from '../lib/entities/attachment';
import { RichMediaState } from '../lib/state';

interface CalculateMeaningfulScoreProps {
	state: RichMediaState;
	hashtagMode: string;
	zeroPointBonuses: boolean;
	attachment?: Attachment | null;
}

export const calculateMeaningfulScore = ({ state, hashtagMode, zeroPointBonuses, attachment }: CalculateMeaningfulScoreProps) => {
	// NOTE: amount is not required if company has zero point recognition enabled
	const amountOptional = zeroPointBonuses;
	// NOTE: hashtag is not required if company has post setting to not require hashtags
	const hashtagOptional = hashtagMode === 'optional';
	const { amount, hashtags, recipients, plainText } = state;

	const hasAmount = !!amount;
	const hasHashtag = hashtags.length > 0;
	const hasRecipient = recipients.length > 0;
	const textLength = plainText.length;

	let percentage = 0;

	// first 20% for the required bonus data; remaining 80% for content
	if (hasRecipient && (hasAmount || amountOptional) && (hasHashtag || hashtagOptional)) {
		percentage += 20;
	}

	// with video percentage is +80
	if (attachment?.category === 'video') {
		percentage += 80;
	}

	// with image percentage is +40
	if (attachment?.category === 'image') {
		percentage += 40;
	}

	//   0% 0-10 characters
	//  20% 11-35 characters
	//  40% 36-85 characters
	//  60% 86-159 characters
	//  80% 160+ characters
	if (textLength > 10) {
		percentage += 20;
	}
	if (textLength > 35) {
		percentage += 20;
	}
	if (textLength > 85) {
		percentage += 20;
	}
	if (textLength > 159) {
		percentage += 20;
	}

	return Math.min(percentage, 100);
};
